import React, {Component} from 'react';
import './SettingsPage.css';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import {authHelper} from "../../helpers/authHelper";
import {apiService} from "../../services/apiService";
import sharedEnv from "../../shared/sharedEnv";
import {withRouter} from "../../hooks/withRouter";
import {withSnackbar} from "../../providers/SnackbarProvider";
import {withDialog} from "../../providers/DialogProvider";
import {localStorageHelper} from "../../helpers/localStorageHelper";
import SnackbarTypeEnum from "../../enums/sanckbarTypeEnum";
import {loadAndApplySettings} from "../../shared/settingsStore";

class SettingsPage extends Component {

  state = {
    loading: true,
    saving: false,
    logoFile: null,
    faviconFile: null,
    backgroundImageFile: null,
    logoPreview: null,
    faviconPreview: null,
    backgroundImagePreview: null,
    introTextEl: '',
    introTextEn: '',
    hrefLink: '',
    hrefAlt: '',
    shareQuote: '',
    hidePeriodsBottomBar: false,
    hideYearSuffix: false,
    useUppercasePeriodName: true,
  };

  componentDidMount() {
    if (this.checkIsAuthed()) {
      this.loadSettings();
    }
  }

  checkIsAuthed = () => {
    if (!authHelper.isAuthed()) {
      setTimeout(() => {
        this.props.navigate('/login');
      }, 100);
      return false;
    }
    return true;
  }

  fileURL(p) {
    return p ? `${sharedEnv.baseURL}/${p}` : null;
  }

  loadSettings = async () => {
    this.setState({loading: true});
    try {
      const s = await apiService.getSettings();
      this.setState({
        loading: false,
        logoFile: null,
        faviconFile: null,
        backgroundImageFile: null,
        logoPreview: this.fileURL(s.logo) || sharedEnv.logoUrl,
        faviconPreview: this.fileURL(s.favicon) || sharedEnv.faviconUrl,
        backgroundImagePreview: this.fileURL(s.backgroundImage) || sharedEnv.backgroundImageUrl,
        introTextEl: (s.introText && s.introText.el) || sharedEnv.introTextGR || '',
        introTextEn: (s.introText && s.introText.en) || sharedEnv.introTextEN || '',
        hrefLink: s.hrefLink || sharedEnv.hrefLink || '',
        hrefAlt: s.hrefAlt || sharedEnv.hrefAlt || '',
        shareQuote: s.shareQuote || sharedEnv.shareQuote || '',
        hidePeriodsBottomBar: typeof s.hidePeriodsBottomBar === 'boolean'
          ? s.hidePeriodsBottomBar : !!sharedEnv.hidePeriodsBottomBar,
        hideYearSuffix: typeof s.hideYearSuffix === 'boolean'
          ? s.hideYearSuffix : !!sharedEnv.hideYearSuffix,
        useUppercasePeriodName: typeof s.useUppercasePeriodName === 'boolean'
          ? s.useUppercasePeriodName : !!sharedEnv.useUppercasePeriodName,
      });
    } catch (error) {
      this.setState({loading: false});
      if (error.response && error.response.status === 401) {
        localStorageHelper.clear();
        this.props.navigate('/login');
        return;
      }
      this.props.showSnackbar({
        message: 'Σφάλμα φόρτωσης ρυθμίσεων',
        snackbarType: SnackbarTypeEnum.ERROR
      });
    }
  }

  onFileSelected = (field) => (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    const previewKey = `${field}Preview`;
    const fileKey = `${field}File`;
    this.setState({
      [fileKey]: file,
      [previewKey]: URL.createObjectURL(file),
    });
  }

  handleTextChange = (field) => (event) => {
    this.setState({[field]: event.target.value});
  }

  handleSwitchChange = (field) => (event) => {
    this.setState({[field]: event.target.checked});
  }

  saveSettings = async () => {
    this.setState({saving: true});

    const formData = new FormData();
    if (this.state.logoFile) formData.append('logo', this.state.logoFile);
    if (this.state.faviconFile) formData.append('favicon', this.state.faviconFile);
    if (this.state.backgroundImageFile) formData.append('backgroundImage', this.state.backgroundImageFile);

    formData.append('introText[el]', this.state.introTextEl || '');
    formData.append('introText[en]', this.state.introTextEn || '');
    formData.append('hrefLink', this.state.hrefLink || '');
    formData.append('hrefAlt', this.state.hrefAlt || '');
    formData.append('shareQuote', this.state.shareQuote || '');
    formData.append('hidePeriodsBottomBar', String(this.state.hidePeriodsBottomBar));
    formData.append('hideYearSuffix', String(this.state.hideYearSuffix));
    formData.append('useUppercasePeriodName', String(this.state.useUppercasePeriodName));

    try {
      await apiService.updateSettings(formData);
      await loadAndApplySettings();
      this.updateFavicon();
      this.props.showSnackbar({
        message: 'Οι ρυθμίσεις αποθηκεύτηκαν',
        snackbarType: SnackbarTypeEnum.SUCCESS
      });
      this.setState({saving: false});
      await this.loadSettings();
    } catch (error) {
      this.setState({saving: false});
      if (error.response && error.response.status === 401) {
        localStorageHelper.clear();
        this.props.navigate('/login');
        return;
      }
      this.props.showSnackbar({
        message: 'Σφάλμα αποθήκευσης ρυθμίσεων',
        snackbarType: SnackbarTypeEnum.ERROR
      });
    }
  }

  updateFavicon = () => {
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = sharedEnv.faviconUrl;
    document.getElementsByTagName('head')[0].appendChild(link);
  }

  logout = () => {
    authHelper.logout();
    this.props.navigate('/login');
  }

  render() {
    const disabled = this.state.loading || this.state.saving;

    return (
      <div className="SettingsPage relative" data-test="settings-page"
           style={{backgroundImage: 'url(' + sharedEnv.backgroundImageUrl + ')'}}>

        <div className="Logout absolute top-3 right-3">
          <Button
            variant="contained"
            onClick={this.logout}
            sx={{
              backgroundColor: 'white',
              color: 'black',
              ":hover": {color: 'white'},
              height: 30,
              boxShadow: 0,
              borderRadius: 0,
            }}
          >
            Αποσύνδεση
          </Button>
        </div>

        <div className="SettingsContainer">
          <Paper className="SettingsPaper">
            <h2 className="SettingsTitle">Ρυθμίσεις</h2>

            <section className="SettingsSection">
              <h3>Εικόνες</h3>

              <div className="ImageRow">
                <div className="ImageBlock">
                  <label>Logo</label>
                  {this.state.logoPreview &&
                    <div className="ImagePreview">
                      <img src={this.state.logoPreview} alt="logo preview"
                           data-test="settings-logo-preview"/>
                    </div>}
                  <input type="file" accept="image/*" disabled={disabled}
                         data-test="settings-logo-input"
                         onChange={this.onFileSelected('logo')}/>
                </div>

                <div className="ImageBlock">
                  <label>Favicon</label>
                  {this.state.faviconPreview &&
                    <div className="ImagePreview">
                      <img src={this.state.faviconPreview} alt="favicon preview"
                           data-test="settings-favicon-preview"/>
                    </div>}
                  <input type="file" accept="image/*,.ico" disabled={disabled}
                         data-test="settings-favicon-input"
                         onChange={this.onFileSelected('favicon')}/>
                </div>

                <div className="ImageBlock">
                  <label>Φόντο</label>
                  {this.state.backgroundImagePreview &&
                    <div className="ImagePreview">
                      <img src={this.state.backgroundImagePreview} alt="background preview"
                           data-test="settings-background-preview"/>
                    </div>}
                  <input type="file" accept="image/*" disabled={disabled}
                         data-test="settings-background-input"
                         onChange={this.onFileSelected('backgroundImage')}/>
                </div>
              </div>
            </section>

            <section className="SettingsSection">
              <h3>Κείμενο εισαγωγής</h3>
              <div data-test="settings-intro-text-el">
                <TextField
                  label="Ελληνικά"
                  multiline
                  minRows={4}
                  fullWidth
                  margin="normal"
                  value={this.state.introTextEl}
                  onChange={this.handleTextChange('introTextEl')}
                  disabled={disabled}
                />
              </div>
              <div data-test="settings-intro-text-en">
                <TextField
                  label="English"
                  multiline
                  minRows={4}
                  fullWidth
                  margin="normal"
                  value={this.state.introTextEn}
                  onChange={this.handleTextChange('introTextEn')}
                  disabled={disabled}
                />
              </div>
            </section>

            <section className="SettingsSection">
              <h3>Σύνδεσμοι & Κοινοποίηση</h3>
              <div data-test="settings-href-link">
                <TextField
                  label="Σύνδεσμος (href)"
                  fullWidth
                  margin="normal"
                  value={this.state.hrefLink}
                  onChange={this.handleTextChange('hrefLink')}
                  disabled={disabled}
                />
              </div>
              <div data-test="settings-href-alt">
                <TextField
                  label="Εναλλακτικό κείμενο (alt)"
                  fullWidth
                  margin="normal"
                  value={this.state.hrefAlt}
                  onChange={this.handleTextChange('hrefAlt')}
                  disabled={disabled}
                />
              </div>
              <div data-test="settings-share-quote">
                <TextField
                  label="Quote κοινοποίησης"
                  fullWidth
                  margin="normal"
                  value={this.state.shareQuote}
                  onChange={this.handleTextChange('shareQuote')}
                  disabled={disabled}
                />
              </div>
            </section>

            <section className="SettingsSection">
              <h3>Επιλογές εμφάνισης</h3>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.hidePeriodsBottomBar}
                    onChange={this.handleSwitchChange('hidePeriodsBottomBar')}
                    disabled={disabled}
                    inputProps={{'data-test': 'settings-hide-periods-bottom-bar'}}
                  />
                }
                label="Απόκρυψη κάτω μπάρας περιόδων"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.hideYearSuffix}
                    onChange={this.handleSwitchChange('hideYearSuffix')}
                    disabled={disabled}
                    inputProps={{'data-test': 'settings-hide-year-suffix'}}
                  />
                }
                label="Απόκρυψη π.Χ./μ.Χ."
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.useUppercasePeriodName}
                    onChange={this.handleSwitchChange('useUppercasePeriodName')}
                    disabled={disabled}
                    inputProps={{'data-test': 'settings-use-uppercase-period-name'}}
                  />
                }
                label="Όνομα περιόδου με κεφαλαία"
              />
            </section>

            <div className="SettingsActions">
              <Button
                variant="contained"
                color="primary"
                onClick={this.saveSettings}
                disabled={disabled}
                data-test="settings-save-button"
              >
                {this.state.saving ? 'Αποθήκευση...' : 'Αποθήκευση'}
              </Button>
            </div>
          </Paper>
        </div>
      </div>
    );
  }
}

export default withSnackbar(withDialog(withRouter(SettingsPage)));
